import { useSearchProductsData } from "@/views/search/hooks/useSearchProductsData";
import ProductsList from "@/views/search/components/search-content/products-list";
import { Container } from "@/components/ui/container";
import S from "./index.module.scss";

const SearchContent = () => {
  const { searchProducts, isLoading, isFetching } = useSearchProductsData();

  return (
    <Container>
      <div className={S.contentWrapper}>
        <ProductsList products={searchProducts} loading={isLoading || isFetching} />
      </div>
    </Container>
  );
};

export default SearchContent;
